import { CuUssdApiRequest } from '@/services/cu-ussd-api.request';
import {
  IAutocreditAccountBody,
  IAutocreditAuthorizeBody,
  IAutocreditMarkPostedBody,
  IAutocreditReprocessBody,
} from '@/types/types';

const AutocreditRequest = CuUssdApiRequest;

export class AutocreditService {
  static fetchReviewPending(query?: string) {
    return AutocreditRequest().get(`/autocredit/review-pending${query || ''}`);
  }

  static authorizeReviewPending(adminId: string, body: IAutocreditAuthorizeBody) {
    return AutocreditRequest().post(`/autocredit/review-pending/authorize`, body, {
      headers: { 'x-admin-id': adminId },
    });
  }

  static fetchLedgers(query?: string) {
    return AutocreditRequest().get(`/autocredit/ledgers${query || ''}`);
  }

  static reprocessLedger(adminId: string, ledgerId: string, body: IAutocreditReprocessBody) {
    return AutocreditRequest().post(`/autocredit/ledgers/${ledgerId}/reprocess`, body, {
      headers: { 'x-admin-id': adminId },
    });
  }

  static markLedgerPosted(adminId: string, ledgerId: string, body: IAutocreditMarkPostedBody) {
    return AutocreditRequest().post(`/autocredit/ledgers/${ledgerId}/mark-posted`, body, {
      headers: { 'x-admin-id': adminId },
    });
  }

  static fetchAccounts(query?: string) {
    return AutocreditRequest().get(`/autocredit/accounts${query || ''}`);
  }

  static upsertAccount(body: IAutocreditAccountBody) {
    return AutocreditRequest().post(`/autocredit/accounts`, body);
  }
}
